<div id="simulation-head-wrap">
  <div id="navwrap" [ngClass]="theme">
    <div class="progress-bar">进行中</div>
    <div class="progress-percent" ><span [innerHTML]="progress" ></span>%</div>
    <div class="progress" *ngIf='!flag' >
      <ul>
        <li *ngFor="let item of stepList;let i = index" [ngStyle]="{'width':progress+'%','max-width': MaxProgress[i] + '%'}" [ngClass]="{'on': item <= currentSteps}">&nbsp;</li>
      </ul>
    </div>
    <div *ngIf='flag'>
      <div id="progressWrap" [ngClass]="theme"  >
        <div class="progress" >
          <div class="progress-inner" [ngStyle]="{'width':progress+'%'}"></div>
        </div>
      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/case-practice-pro-nav/case-practice-pro-nav.component.html